import windowReducer from './windowReducer'
import videoPlayerReducer from './videoPlayerReducer'
import authReducer from "./authReducer"

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    window: windowReducer,
    videoPlayer: videoPlayerReducer,
    auth: authReducer,
}
